<template>
    <div>
      <Warehouse_all/>
    </div>
  </template>
  
  <script>
  import Warehouse_all from "@/components/adminArin/pos_system/warehouse/warehouse_all/Warehouse_all";
  export default {
    name: "Warehouseall",
    components: {
      Warehouse_all
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  